<ngx-select-dropdown [(ngModel)]="defaultValue" (change)="valueChanged($event)"
                     [config]="config" [options]="mappedList"></ngx-select-dropdown>

